"use strict";

const BaseEnforcementController = require("../../enforcement/baseEnforcementController");

const IncidentEnforcementController = function () {
  const formKey = "incident-enforcement";
  const htmlPath = "modals/incidentEnforcement";
  const headerTemplate = "modals/incidentEnforcement/incidentEnforcementHeader.njk";

  const getTabModules = () => {
    return {
      EnforcementAction: require("./enforcementAction"),
      EnforcementLetterManagement: require("./enforcementLetterManagement"),
      EnforcementHistory: require("./enforcementHistory"),
    };
  };

  const newEnforcementApiFunction = (incidentId) => ApiCalls.getNewIncidentEnforcement(incidentId);
  const getEnforcementApiFunction = (enforcementId) =>
    ApiCalls.getIncidentEnforcement(enforcementId);
  const createEnforcementApiFunction = (formData) => ApiCalls.issueIncidentEnforcement(formData);
  const updateEnforcementApiFunction = (formData) => ApiCalls.updateIncidentEnforcement(formData);

  const getAssetNameFunction = (data) => data.incident.incidentName;
  const getAssetIdFunction = (data) => {
    return { incidentId: data.incident.id };
  };

  const afterHideFunction = () => {
    IncidentsGeoServerLayer.invalidateLayerData();
    ToDoListController.loadTodos();
  };

  const base = BaseEnforcementController(
    formKey,
    htmlPath,
    headerTemplate,
    getTabModules,
    newEnforcementApiFunction,
    getEnforcementApiFunction,
    createEnforcementApiFunction,
    updateEnforcementApiFunction,
    getAssetNameFunction,
    getAssetIdFunction,
    { afterHideFunction },
  );

  return {
    ...base,
  };
};

module.exports = IncidentEnforcementController();

const IncidentsGeoServerLayer = require("../incidents/incidentsGeoServerLayer");
const ApiCalls = require("../../apiCalls");
const ToDoListController = require("../../mapFunctions/toDoListController");
